// @core/api/endpoints/tag/list_tags.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTagsResponse,
} from '../../../types/tag';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/tag';

/**
 * List tags
 * Returns a paginated list of tags visible to the current actor. Automatically filters by visibility rules: tenant tags are always shown, team tags only for team members, personal tags only for the owner.
 */
export async function ListTags(
  params?: PaginatedRequest & {
    product_id?: string | number | boolean;
    q?: string | number | boolean;
    visibility?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListTagsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tags`;
  const requestOptions = options;
  return client.get<ListTagsResponse>(requestPath, { ...requestOptions, params });
}
